import { PropsWithChildren } from "react";
import { FreeMode, Mousewheel } from "swiper/modules";
import { Swiper } from "swiper/react";

const SearchResultSwiper = ({ children }: PropsWithChildren) => {
  return (
    <Swiper
      className="!overflow-visible"
      spaceBetween={24}
      freeMode={{
        enabled: true,
        sticky: false,
        momentumBounce: false,
      }}
      modules={[Mousewheel, FreeMode]}
      mousewheel={{ forceToAxis: true }}
      slidesPerView="auto"
    >
      {children}
    </Swiper>
  );
};
export default SearchResultSwiper;
